import i18next from 'i18next';
import { makeKey } from '../../common/translationKey';

export enum UniformEra {
  None,
  DominionWar,
  Cardassian,
  Civilian,
  Enterprise,
  JemHadar,
  Klingon,
  LowerDecks,
  MonsterMaroon,
  NextGeneration,
  OriginalSeries,
  OriginalSeriesKlingon,
  Romulan,
  Suliban,
  VoyagerDS9,
  Bynar,
  Ferengi,
  StrangeNewWorlds,
  Maco,
  TheMotionPicture,
  Discovery23,
  StarTrekOnline,
  RomulanNemesis,
  Tzenkethi,
  Prodigy,
  PicardRomulanEvacuation,
  Picard25,
  Discovery32,
  StarfleetAcademy,
}

export const allUniformEras = (): UniformEra[] => {
  return Object.keys(UniformEra)
    .filter((item) => {
      return !isNaN(Number(item));
    })
    .map((item) => Number(item));
};

export class UniformEraModel {
  id: UniformEra;
  name: string;

  constructor(id: UniformEra, name: string) {
    this.id = id;
    this.name = name;
  }

  get localizedName() {
    const key = makeKey('UniformEra.', UniformEra[this.id]);
    const result = i18next.t(makeKey('UniformEra.', UniformEra[this.id]));
    return result === key ? this.name : result;
  }
}

export class UniformEraHelper {
  private static singleton: UniformEraHelper;

  types = [
    new UniformEraModel(UniformEra.None, 'None'),
    new UniformEraModel(UniformEra.Bynar, 'Bynar'),
    new UniformEraModel(UniformEra.Cardassian, 'Cardassian'),
    new UniformEraModel(UniformEra.Civilian, 'Civilian'),
    new UniformEraModel(UniformEra.Discovery23, 'Discovery (23rd Century)'),
    new UniformEraModel(UniformEra.Discovery32, 'Discovery (32nd Century)'),
    new UniformEraModel(UniformEra.Enterprise, 'Enterprise'),
    new UniformEraModel(UniformEra.Ferengi, 'Ferengi'),
    new UniformEraModel(UniformEra.Klingon, 'Klingon Armour'),
    new UniformEraModel(UniformEra.DominionWar, 'Dominion War'),
    new UniformEraModel(UniformEra.LowerDecks, 'Lower Decks'),
    new UniformEraModel(UniformEra.JemHadar, "Jem'Hadar"),
    new UniformEraModel(UniformEra.Maco, 'MACO'),
    new UniformEraModel(UniformEra.NextGeneration, 'The Next Generation'),
    new UniformEraModel(UniformEra.OriginalSeries, 'Original Series'),
    new UniformEraModel(UniformEra.TheMotionPicture, 'The Motion Picture'),
    new UniformEraModel(
      UniformEra.OriginalSeriesKlingon,
      'Klingon (Original Series)',
    ),
    new UniformEraModel(UniformEra.Romulan, 'Romulan'),
    new UniformEraModel(UniformEra.RomulanNemesis, 'Romulan (Nemesis)'),
    new UniformEraModel(UniformEra.StrangeNewWorlds, 'Strange New Worlds'),
    new UniformEraModel(UniformEra.Suliban, 'Suliban'),
    new UniformEraModel(UniformEra.VoyagerDS9, 'Voyager/DS9'),
    new UniformEraModel(
      UniformEra.MonsterMaroon,
      'The Wrath of Khan and Later Movies',
    ),
    new UniformEraModel(UniformEra.Prodigy, 'Prodigy'),
    new UniformEraModel(
      UniformEra.PicardRomulanEvacuation,
      'Picard (Romulan Evacuation)',
    ),
    new UniformEraModel(UniformEra.Picard25, 'Picard (25th Century)'),
    new UniformEraModel(UniformEra.StarfleetAcademy, 'Starfleet Academy'),
    new UniformEraModel(UniformEra.StarTrekOnline, 'Star Trek Online'),
    new UniformEraModel(UniformEra.Tzenkethi, 'Tzenkethi'),
  ];

  static get instance() {
    if (UniformEraHelper.singleton == null) {
      UniformEraHelper.singleton = new UniformEraHelper();
    }
    return UniformEraHelper.singleton;
  }
}
